import DataAccess from './constants';
import API from './API'

const path = 'MenusAndPages'
let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const apiMenusAndPages = (applicationId) => {
    let newpath = path + "?ApplicationId=" + applicationId;
    return api.getData(newpath)
}
